//For expanding sidebar
import {
  CLEAR_CURRENT_DOWNLOAD_ITEM,
  CLEAR_CURRENT_MOVIE,
  CREATE_BUNDLE,
  CREATE_DOWNLOAD,
  CREATE_DOWNLOAD_ITEM,
  CREATE_MOVIE,
  DELETE_BUNDLE,
  DELETE_DOWNLOAD_ITEM,
  DELETE_MOVIE,
  DOWNLOAD_IS_CREATED,
  GENERATE_FREE_DOWNLOAD_ITEM,
  GET_BUNDLE,
  GET_BUNDLE_ITEM_MOVIE,
  GET_COMPANIES_LIST,
  GET_COMPANY,
  GET_CURRENT_MOVIE,
  GET_DOWNLOADS_INFINITE_LIST,
  GET_DOWNLOADS_LIST,
  GET_DOWNLOAD_ITEM,
  GET_DOWNLOAD_ITEM_LIST,
  GET_GENRE,
  GET_MOVIE_INFO,
  GET_PROFESSION,
  GET_PROFESSIONS_LIST,
  RESET_DOWNLOADS_INFINITE_LIST,
  SET_CURRENT_MOVIE,
  SET_FILTER_BUNDLE,
  SET_FILTER_TYPE,
  SET_POSTER_PROPS,
  UPDATE_BUNDLE,
  UPDATE_DOWNLOAD,
  UPDATE_DOWNLOAD_ITEM,
  UPDATE_MOVIE,
  UPDATE_POSTER,
} from '../../@jumbo/constants/ActionTypes';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import { client } from 'services/http';

//For setting Filtertype
export const setFilterType = filterType => {
  return {
    type: SET_FILTER_TYPE,
    payload: filterType,
  };
};

export const getBundleItemMovies = (params, page) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/download_items/`, {
        params: {
          ...params,
          page,
        },
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_BUNDLE_ITEM_MOVIE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getBundledList = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v3/bundle_items/?by_parent_download_item_id=${id}&per_page=40`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_BUNDLE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const removeBundleItem = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v3/bundle_items/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_BUNDLE, payload: id });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const setFilterBundleType = filterBundle => {
  return {
    type: SET_FILTER_BUNDLE,
    payload: filterBundle,
  };
};

//for getting movie list
export const getMovieList = (params, isDropdown) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v2/movies`, { params: { ...params } })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          if (isDropdown) {
            dispatch({ type: GET_DOWNLOADS_INFINITE_LIST, payload: data.data });
          } else {
            dispatch({ type: GET_DOWNLOADS_LIST, payload: data.data })
          }
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const resetMovieInfiteList = () => {
  return dispatch => {
    dispatch({
      type: RESET_DOWNLOADS_INFINITE_LIST,
    })
  }
}

export const setCurrentMovie = movieId => {
  return dispatch => {
    dispatch({
      type: SET_CURRENT_MOVIE,
      payload: movieId,
    });
  };
};

export const clearCurrentMovieInfo = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_CURRENT_MOVIE,
    });
  };
};

export const getCurrentMovieInfo = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v3/downloads/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_CURRENT_MOVIE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const createDownload = download => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post('/share/v3/downloads', download)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('دانلود شما با موفقیت ساخته شد'));
          dispatch(setCreatedDownload(true));
          localStorage.setItem('downloadId', data.data.id);
          dispatch({ type: CREATE_DOWNLOAD, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      });
  };
};

export const updateDownload = ({ download, id }) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`/share/v3/downloads/${id}`, download)
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess('بروز رسانی با موفقیت انجام شد'));
          dispatch({ type: UPDATE_DOWNLOAD, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const createDownloadItem = ({ downloadId, data }, history, pathToBack) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`/share/v3/downloads/${downloadId}/download_items/`, data)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('با موفقیت ثبت شد'));
          dispatch({ type: CREATE_DOWNLOAD_ITEM, payload: data.data });
          history.push(pathToBack);
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const updateDownloadItem = ({ id, downloadId, data }) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`share/v3/downloads/${downloadId}/download_items/${id}`, data)
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess('تغییرات شما ثبت شد'));
          dispatch({ type: UPDATE_DOWNLOAD_ITEM, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getDownloadItem = ({ downloadId, id, movieType }, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`share/v3/downloads/${downloadId}/download_items/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_DOWNLOAD_ITEM, payload: data.data });
          history.push(`/create-movie/?ui=${id}&p=${downloadId}&type=${movieType}`);
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const generateFreeDownloadItem = downloadId => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`/share/v1/free_download_items`, {
        download_id: downloadId,
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('لینک‌های رایگان ساخته شد'));
          dispatch({ type: GENERATE_FREE_DOWNLOAD_ITEM, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const setCreatedDownload = status => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_IS_CREATED,
      payload: status,
    });
  };
};

export const getDownloadItems = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v3/downloads/${id}/download_items`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_DOWNLOAD_ITEM_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const deleteDownloadItem = (id, downloadId) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v3/downloads/${downloadId}/download_items/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_DOWNLOAD_ITEM, payload: id });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const clearCurrentDownloadItem = () => {
  return dispatch => {
    dispatch({ type: CLEAR_CURRENT_DOWNLOAD_ITEM });
  };
};

export const createBundle = item => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post('/share/v3/bundle_items', item)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('با موفقیت ثبت شد'));
          dispatch({ type: CREATE_BUNDLE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

//for updating episode through detail page
export const updateBundle = (bundle, id) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`/share/v3/bundle_items/${id}`, { bundle })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('تغییرات شما ثبت شد'));
          dispatch({ type: UPDATE_BUNDLE, payload: bundle });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const putDownloadType = (movie, jumpToList) => {
  return dispatch => {
    client
      .put(`/share/v2/movie/${movie.uid}`, {
        product_type: movie.product_type,
      })
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess());
          jumpToList();
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getComaniesList = id => {
  return dispatch => {
    client
      .get(`/share/v1/companies/`, {
        params: {
          per_page: 80,
        },
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_COMPANIES_LIST, payload: data.data.companies });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getComany = id => {
  return dispatch => {
    client
      .get(`/share/v1/companies/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_COMPANY, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};


// Movie root manangement
export const getMovieInfo = id => {
  return dispatch => {
    client
      .get(`/share/v2/movie/${id}.json`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_MOVIE_INFO, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getProfessionsList = () => {
  return dispatch => {
    client
      .get(`/share/profession.json`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_PROFESSIONS_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const findProfessions = (name) => {
  return dispatch => {
    client
      .get(`/share/v1/search/user?query=${name}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_PROFESSION, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const updateMoviePoster = ({ posterData, movieId, history, setUploadLoading }) => {
  return dispatch => {
    const formData = new FormData();
    formData.append('poster', posterData);

    client
      .put(`/share/v2/movie/${movieId}/update_poster.json`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(data => {
        if (data.status === 202) {
          dispatch(fetchSuccess('پوستر با موفقیت بروزرسانی شد'));
          dispatch({ type: UPDATE_POSTER, payload: data.data });
          if (history) {
            history.push('/movie')
          }
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      })
      .finally(() => {
        setUploadLoading(false)
      });
  };
};

export const createMovieRoot = ({ movieData, history, posterProps, setUploadLoading }) => {
  return dispatch => {
    client
      .post(`/share/v2/movie.json`, movieData)
      .then(data => {
        if (data.status === 201) {
          dispatch(fetchSuccess('فیلم با موفقیت ثبت شد'));
          dispatch({ type: CREATE_MOVIE, payload: data.data });
          if (posterProps) {
            setUploadLoading(true);
            dispatch(updateMoviePoster({ posterData: posterProps, movieId: data.data.uid, setUploadLoading, history }))
          } else {
            history.push('/movie')
          }
        } else {
          dispatch(fetchError('Something went wrong from create movie'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data[0]));
      });
  };
};

export const updateMovieRoot = (data, movieId) => {
  return dispatch => {
    client
      .put(`/share/v2/movie/${movieId}.json`, data)
      .then(data => {
        if (data.status === 202) {
          dispatch(fetchSuccess('فیلم با موفقیت بروزرسانی شد'));
          dispatch({ type: UPDATE_MOVIE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const duplicateMovieRoot = ({ movieId, duplicateNumber, movieName, setDuplicateLoading }) => {
  return dispatch => {
    client
      .post(`/share/v1/cloning_movies`, {
        movie_id: movieId,
        cloning_count: duplicateNumber
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess(`فیلم ${movieName} به تعداد ${duplicateNumber} کپی شد`));
        } else {
          dispatch(fetchError('Something went wrong from create movie'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      })
      .finally(() => {
        setDuplicateLoading(false);
      });
  };
};

export const deleteMovieRoot = movieId => {
  return dispatch => {
    client
      .delete(`/share/v2/movie/${movieId}.json`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('فیلم مورد نظر حذف شد'));
          dispatch({ type: DELETE_MOVIE, payload: movieId })
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getGenre = () => {
  return dispatch => {
    client
      .get(`/share/movie/genre.json`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_GENRE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const setPosterProps = poster => {
  return dispatch => {
    dispatch({
      type: SET_POSTER_PROPS,
      payload: poster,
    });
  };
};
